import Vue from 'vue';
import Vuex from 'vuex';

import countries from './modules/countries';
import notifications from './modules/notification/notifications';
import auth from './modules/auth';
import register from './modules/register';
import materials from './modules/material/materials';
import materialGroups from './modules/material_group/materialGroups';
import admin from './modules/admin/admin';
import companies from './modules/company/companies';
import offer from './modules/offer/offer';
import chat from './modules/chat/chat';
import exchanges from './modules/exchange/exchanges';
import users from './modules/user/users';
import recommendedMaterials from './modules/material/recommendedMaterials';
import filters from './modules/filters/filters';
import locale from './modules/locale';
import demo from './modules/demo';
import synergy from './modules/synergy';
import donationsDashboard from './modules/donations_dashboard/donations';
import driver from './driver';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    admin,
    auth,
    chat,
    companies,
    countries,
    demo,
    donationsDashboard,
    driver,
    exchanges,
    locale,
    materialGroups,
    materials,
    notifications,
    offer,
    recommendedMaterials,
    register,
    users,
    filters,
    synergy,
  },
});
